import { useMutation } from '@tanstack/react-query';

import { Api } from '@/shared/api';
import { useCurrentProject } from '@/shared/projects/project-path';

export function useCreatePublisherMutation() {
  const project = useCurrentProject();
  return useMutation({
    mutationFn: (data: Parameters<typeof Api.publishers.createPublisher>[1]) =>
      Api.publishers.createPublisher(project, data),
  });
}

export function useUploadPublisherPreviewMutation() {
  const project = useCurrentProject();
  return useMutation({
    mutationFn: (
      file: Parameters<typeof Api.publishers.uploadPublisherPreview>[1],
    ) => Api.publishers.uploadPublisherPreview(project, file),
  });
}
